export default "__VITE_ASSET__CJTFgv5r__"